// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useI18n } from "@/i18n"

interface LoadingStateProps {
  label?: string
  className?: string
}

/** Truthful, minimal loading indicator — never a fake skeleton of specific data. */
export function LoadingState({ label, className }: LoadingStateProps) {
  const { t } = useI18n()
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center justify-center gap-3 py-10 text-ink-2 ${className ?? ""}`}
    >
      <span
        aria-hidden="true"
        className="size-5 animate-spin rounded-full border-2 border-line border-t-green"
      />
      <span>{label ?? t("state.loading")}</span>
    </div>
  )
}
